import React from 'react';
import CorbeilleSvg from './SVG/CorbeilleSvg';
import CrayonSvg from './SVG/CrayonSvg';
import DupliquerSvg from "./SVG/DupliquerSvg";
import QuitterSvg from "./SVG/QuitterSvg";
import DragDropSvg from "./SVG/DragDropSvg";
import CroixSvg from "./SVG/CroixSvg";
import CarreFlecheSortante from "./SVG/CarreFlecheSortante";
import PhidgetSvg from "./SVG/PhidgetSvg";
import ParametreSvg from "./SVG/ParametreSvg";
import FlecheRevenirSvg from "./SVG/FlecheRevenirSvg";
import TroisPointsSvg from "./SVG/TroisPointsSvg";
import AncrageSvg from "./SVG/AncrageSvg";
import AnnotationSvg from "./SVG/AnnotationSvg";
import AideSvg from "./SVG/AideSvg";

const BtnSvg = ({svg, onClick, style, taille, width = 20, height = 20, couleur}) => {
    const defaultStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        cursor: "pointer"
    };

    const stopPropagation = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    let size;
    if (taille === "grand") {
        size = {width: 40, height: 40};
    } else if (taille === "petit") {
        size = {width: 20, height: 20};
    } else {
        size = {width: width || 20, height: height || 20};
    }

    const renderSvg = () => {
        switch (svg) {
            case "corbeille":
                return <CorbeilleSvg width={size.width} height={size.height}/>;
            case "crayon":
                return <CrayonSvg width={size.width} height={size.height}/>;
            case "dupliquer":
                return <DupliquerSvg width={size.width} height={size.height}/>;
            case "quitter":
                return <QuitterSvg width={size.width} height={size.height}/>;
            case "drag_drop":
                return <DragDropSvg width={size.width} height={size.height}/>;
            case "croix":
                return <CroixSvg width={size.width} height={size.height}/>;
            case "carre_fleche_sortante":
                return <CarreFlecheSortante width={size.width} height={size.height}/>;
            case "phidget":
                return <PhidgetSvg width={size.width} height={size.height}/>;
            case "parametre":
                return <ParametreSvg width={size.width} height={size.height} couleur={couleur}/>;
            case "fleche_revenir":
                return <FlecheRevenirSvg width={size.width} height={size.height}/>;
            case "trois_points":
                return <TroisPointsSvg width={size.width} height={size.height}/>;
            case "ancrage":
                return <AncrageSvg width={size.width} height={size.height} couleur={couleur}/>;
            case "annotation":
                return <AnnotationSvg width={size.width} height={size.height} couleur={"#002335"}/>;
            case "aide":
                return <AideSvg width={size.width} height={size.height} couleur={couleur}/>;
            default:
                return <div>Erreur BtnSVG {svg}</div>;
        }
    };

    return (
        <div style={{...defaultStyle, ...style}} onTouchStart={onClick} onClick={onClick} onMouseDown={stopPropagation} onTouchStartCapture={stopPropagation}>
            {renderSvg()}
        </div>
    );
};

export default BtnSvg;